import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { ButtonGobackComponent } from '../button-goback/button-goback.component';

@Component({
    selector: 'app-go-back-and-title',
    imports: [ButtonGobackComponent],
    templateUrl: './go-back-and-title.component.html',
    styleUrls: ['./go-back-and-title.component.css']
})
export class GoBackAndTitleComponent {
  @Input() titulo!:string
  @Input() returnUrl!:string

}
